import React, {useMemo} from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import useAnimatedNavToggler from "hooks/useAnimatedNavToggler.js";
import AuthContext from 'contexts/AuthContext';

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from "images/logo.png";

const Image = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-64 sm:h-80 bg-center bg-cover rounded-t`}
`;
const Header = tw.header`
  flex justify-between items-center mx-auto
`;

export const NavLinks = tw.div`flex`;
export const NavLink = tw.a`my-2 lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500
`;
export const PrimaryLink = tw(NavLink)`
  lg:mx-0
  px-8 py-3 rounded bg-primary-500 text-gray-100
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0
`;

export const MobileNavLinksContainer = tw.nav`flex flex-1 items-center justify-between`;
export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hocus:text-primary-500 transition duration-300
`;
export const MobileNavLinks = motion(styled.div`
  ${tw`lg:hidden z-10 fixed top-0 right-0 text-sm mx-4 my-6 p-8 border text-center rounded-lg bg-white`}
  ${NavLinks} {
    ${tw`flex flex-col items-center`}
  }
`);
const DesktopNavLinks = tw.nav`
  hidden lg:flex flex-1 justify-between items-center
`;
const Name = tw.a`font-semibold text-primary-900 my-2 lg:mx-6 lg:my-0 capitalize cursor-pointer hocus:text-primary-500`;
const LogoutButton = tw.button`
  text-sm my-2 lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 lg:border-transparent hover:border-primary-500 hocus:text-primary-500
`

const getGoogleUrl = () => {
  const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;
  const options = {
    redirect_uri: 'https://sso.agcoa.in/v1/sessions/oauth/google',
    client_id: '239001656320-3iubiq7nl1otp8tr46ptaq2k9dj9hjmb.apps.googleusercontent.com',
    access_type: 'offline',
    response_type: 'code',
    prompt: 'consent',
    state: 'agcoa',
    scope: [
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/userinfo.email',
    ].join(' '),
  };
  const qs = new URLSearchParams(options);
  return `${rootUrl}?${qs.toString()}`;
};

export default () => {
  const cbc = cbcMap["lg"];
  const {role, user, logout} = React.useContext(AuthContext);
  const {showNavLinks, animation, toggleNavbar} = useAnimatedNavToggler();

  const curPage = useMemo(() => {
    return window.location.pathname.split('/')[1];
  }, [])

  const links = [
    <NavLinks key={1} >
      <NavLink href="/" >Home</NavLink>
      {role && role !== "USER" && role !== "REGISTER" &&
        <NavLink href="/documents" style={{borderBottom: curPage === "documents" ? '0.15rem solid #5fbd92': 'inherit'}}>Documents</NavLink>
      }
      {role && role !== "USER" && role !== "REGISTER" && <NavLink href="/finance">Finance</NavLink>}
      {role && role !== "USER" && role !== "REGISTER" && <NavLink href="/invoices">Invoices</NavLink>}
      {role && role !== "USER" && role !== "REGISTER" && <NavLink href="/members">Members</NavLink>}
      {user?.name &&
        <Name href="/profile">{user.name}</Name>
      }
      {user?.name ?
        <LogoutButton onClick={logout}>Logout</LogoutButton>
        :
        <NavLink href={getGoogleUrl()}>Login</NavLink>
      }
    </NavLinks>
  ];

  return (
    <Header className={"header-light"}>
      <DesktopNavLinks css={cbc.desktopNavLinks}>
        <Image imageSrc={Logo} style={{height: 80, width: 80}} />
        <div style={{marginTop: '-40px'}}>{links}</div>
      </DesktopNavLinks>
      <MobileNavLinksContainer css={cbc.mobileNavLinksContainer}>
        Aspen Greens, UniHomes
        <MobileNavLinks initial={{ x: "150%", display: "none" }} animate={animation} css={cbc.mobileNavLinks}>
          {links}
        </MobileNavLinks>
        <NavToggle onClick={toggleNavbar} className={showNavLinks ? "open" : "closed"}>
          {showNavLinks ? <CloseIcon tw="w-6 h-6" /> : <MenuIcon tw="w-6 h-6" />}
        </NavToggle>
      </MobileNavLinksContainer>
    </Header>
  );
};

const cbcMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  }
};
